import React, { useState } from "react";
import PropTypes from 'prop-types';
import renderModal from '@components/show_page/modals/renderModal';

function AddLabelModal(props) {
  const [labelName, updateName] = useState([]);

  const createLabel = () => {
    const { addLabel, activeLabel } = props;
    const newLabelData = { name: labelName, parent_key: activeLabel.parentKey };
    addLabel(newLabelData);
  };

  const { toggleModal, activeLabel } = props;
  const parentName = activeLabel.parentName ? `under ${activeLabel.parentName}` : "at top level";
  return (
    <div className="modal-content-wrapper add-labels-modal">
      <div className="modal-content-wrapper__header">
        <span className="bff-label icon" aria-hidden="true" />
        <h2 className="modal-title">{t("Add Label")}</h2>
      </div>
      <div className="modal-content-wrapper__body">
        <h2 className="body-title">
          {`${t('Add new label')} ${parentName}`}
        </h2>
        <label htmlFor="name">
          Name:
          <input
            className="input form-html-label"
            type="text"
            name="name"
            placeholder="Label Name"
            onChange={(e) => updateName(e.target.value)}
            autoFocus
          />
        </label>
        <div className="button-container">
          <button
            className="button tertiary sm t-close-modal"
            onClick={() => toggleModal()}
            type="button"
          >
            {t('Cancel')}
          </button>
          <button
            className="button sm primary t-confirm-modal"
            disabled={!labelName.length}
            onClick={createLabel}
            type="button"
          >
            {t('Add')}
          </button>
        </div>
      </div>
    </div>
  );
}

AddLabelModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  addLabel: PropTypes.func.isRequired,
  activeLabel: PropTypes.shape({
    actionType: PropTypes.string,
    parentKey: PropTypes.string,
    name: PropTypes.string,
  }).isRequired
};

const ModalComponent = renderModal(AddLabelModal, 'AddLabelModal');
export default ModalComponent;
